import React, { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PropertyContext = createContext(null);
export const useProperty = () => useContext(PropertyContext);

export function PropertyProvider({ children }) {
  const { user } = useAuth();
  const [properties, setProperties] = useState([]);
  const [selectedId, setSelectedId] = useState(
    () => localStorage.getItem("selectedPropertyId") || ""
  );
  const [loading, setLoading] = useState(true);

  const reload = async () => {
    try {
      const { data } = await api.get("/properties");
      setProperties(data);
      if (data.length > 0) {
        const exists = data.find((p) => p.id === selectedId);
        if (!exists) {
          setSelectedId(data[0].id);
          localStorage.setItem("selectedPropertyId", data[0].id);
        }
      } else {
        setSelectedId("");
      }
    } catch {
      setProperties([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const selectProperty = (id) => {
    setSelectedId(id);
    localStorage.setItem("selectedPropertyId", id);
  };

  const selected = properties.find((p) => p.id === selectedId) || null;

  return (
    <PropertyContext.Provider
      value={{ properties, selected, selectedId, selectProperty, reload, loading }}
    >
      {children}
    </PropertyContext.Provider>
  );
}
